import React from 'react'
import emailIcon from "../../icons/mailIcon.png"
import phoneIcon from "../../icons/phoneIcon.png"
import igIcon from "../../icons/igIcon.png"

function Contacto() {
  return (
    <div >
        <h1 className=" text-center col-12 pt-5 mb-5 tittleText fw-bold px-5">Contáctanos</h1>

        <div className='p-5 d-flex flex-row justify-content-center flex-wrap'>
            <div className="d-flex flex-column gap-3 col-11 col-md-4">
                <h1>Datos</h1>
                <span className='d-flex size flex-row align-items-center gap-2'>
                    <img className="opacity" width="35px" src={emailIcon} alt="emailIcon" />
                    <span className='d-md-none d-flex flex-wrap'>
                        <span className='fs-4 grey col-12 regularText'>carbono.zero.arg</span><span className='regularText fs-4 grey col-12'>@gmail.com</span>
                    </span>
                    <span className='d-none d-md-block regularText fs-4 grey'>carbono.zero.arg@gmail.com</span>

                </span>
                <span className='d-flex flex-row align-items-center gap-2'>
                    <img className="opacity" width="35px" src={igIcon} alt="igIcon" />
                    <span className='regularText fs-4 grey'>@carbono_zero_arg</span>
                </span>
                <span className='d-flex flex-row align-items-center gap-2'>
                    <img className="opacity" width="35px" src={phoneIcon} alt="phoneIcon" />
                    <span className='regularText fs-4 grey'>385 574 6119</span>
                </span>
                <span className='d-flex flex-row align-items-center gap-2'>
                    <img className="opacity" width="35px" src={phoneIcon} alt="phoneIcon" />
                    <span className='regularText fs-4 grey'>385 412 5141</span>
                </span>
            </div>

            <div className='d-none d-md-flex flex-column gap-3 col-11 col-md-4 ps-4'>
                <h1>Ubicación</h1>
                <p className='regularText fs-4 grey'>4200, Santiago del Estero Capital, Santiago del Estero. Argentina.</p>
            </div>

            <div className='d-flex d-md-none flex-column gap-3 col-11 col-md-4 my-5'>
                <h1>Ubicación</h1>
                <p className='regularText fs-4 grey'>4200, Santiago del Estero Capital, Santiago del Estero. Argentina.</p>
            </div>

            <div className="d-flex flex-column mb-4 military1Bg rounded p-3 col-11 col-md-4">
                <h1 className="text-white">Dejar un mensaje</h1>
                <form action="" className='d-flex flex-column gap-2'>
                    <input className='form-control form-contorl-lg' type="text" placeholder='Nombre'required/>
                    <input className='form-control form-contorl-lg' type="text" placeholder='Email'required/>
                    <textarea className='form-control form-contorl-lg' placeholder='Mensaje' required/>
                    <button className="btn btn-success fw-bold regularText">Enviar</button>
                </form>
            </div>


        </div>
    </div>
  )
}

export default Contacto